// 国外跟踪的接口
import { request } from "@/utils/request.js";
import { axiosAbroadEnum, axiosAbroadOrderEnum } from "./enum";

const baseURL = axiosAbroadEnum[process.env.VUE_APP_API_ENV];
const festURL = axiosAbroadOrderEnum[process.env.VUE_APP_API_ENV];

/**
 * @description 节点状态code枚举
 * @param {number} limit 限制条数
 * @param {number} page 页码
 */
export function getNodeStatusCodeList(token) {
    return request(
        "/shipping-center/bill/ship-status/list",
        "post",
        {
            page: 1,
            limit: 1000,
        },
        {
            baseURL,
            headers: {
                Authorization: token,
            },
        },
    );
}

/**
 * @description 基于提单号检测船司
 * @param {string} blno 提单号
 */
export function checkCarrierByBillNo(param) {
    return request(
        "/shipping-center/bill/checkShip",
        "post",
        param,
        {
            baseURL,
        },
        true,
    );
}

/**
 * @description 查询提单信息(国外)
 * @param {string} billNo 提单号
 * @param {string} shipCode 船司
 */
export function getBillNoInfoAbroad(data) {
    return request(
        "/shipping/getBillNoInfo",
        "post",
        data,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

/**
 * @description 查询提单信息(国外)--新版本
 * @param {string} billNo 提单号
 * @param {number} userBillld 提单id
 */
export function getBillNoInfoAbroadNew(data, token) {
    return request("/shipping-center/bill/info", "get", data, {
        baseURL: festURL,
        headers: {
            Authorization: token,
        },
    });
}

/**
 * @description 获取船公司信息，用于Logo对应
 */

export const getShipCompanyInfoRequest = () => {
    // 请求线上版本,带时间戳，最新的
    return new Promise((resolve, reject) => {
        fetch(
            `https://web.nbhuojian.com/static/ship-company-logo/index.json?t=${new Date().getTime()}`,
        )
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            });
    });
};

/**
 * @description 重新订阅国外(宁波)
 * @param {number} id 订阅id
 * @param {string} shipCode 船司
 * @param {string} port 港口 // NB、SZ、XM、QD、TJ、DL
 */
export function subAbroadById(data) {
    const { port, ...restData } = data;
    // port为大写字母，转为首字母大写，后面的字母小写
    const newPort =
        port === "NB"
            ? ""
            : port.charAt(0).toUpperCase() + port.slice(1).toLowerCase();
    return request(
        `/blno/userBlno${newPort}/subscribeAbroad`,
        "post",
        restData,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

/**
 * @description 刷新
 * @param {string} shipCode 船司
 * @param {string} portCode
 */
export function refreshAbroad(data) {
    return request(
        "/shipping/autoUpdate",
        "post",
        data,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

/**
 * @description 获取支持的船公司
 */
export function getSupportCompanyList() {
    return request(
        "/shipping-center/bill/ship-company/list",
        "post",
        {
            limit: "1000",
            page: "1",
        },
        {
            baseURL,
        },
    );
}

/**
 * @description 修改船公司
 * @param {Number} id 船公司id
 * @param {String} portCode 港口代码
 * @param {String} shipCode 船公司代码
 */

export function updateShipCompany(data) {
    return request(
        "/shipping/updateShip",
        "post",
        data,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

/**
 * @description 用户独立订阅的海外运踪提单号列表
 * @param {Number} limit
 * @param {Number} page
 * @param {String} billNo
 * @param {String} shipCode
 * @param {String} remark
 * @param {String} statusCodeStr
 * @param {Number} type  是否删除，0：否，-1：是，默认0
 * @param {String} [token] 可选，小程序 webview 等场景传入 query.token 作为 Authorization
 */
export function abroadSinglePageSubsList(param, token) {
    const opts = { baseURL };
    if (token) {
        opts.headers = { Authorization: token };
    }
    return request("/app/abroad-blno-subscribe/list", "post", param, opts);
}

/**
 * @description 创建用户独立订阅的海外运踪提单号
 * @param {String} billNo
 * @param {String} shipCode
 * @returns
 */
export function abroadSinglePageSubsAdd(param) {
    return request("/app/abroad-blno-subscribe/save", "post", param, {
        baseURL,
    });
}

/**
 * @description 修改备注或者船司
 * @param {Number} id
 * @param {String} remark
 * @param {String} shipCode
 */
export function abroadSinglePageSubsUpdate(param) {
    return request("/app/abroad-blno-subscribe/update", "post", param, {
        baseURL,
    });
}

/**
 * @description 删除用户独立订阅的海外运踪提单号
 * @param {Array} ids
 */
export function abroadSinglePageSubsDel(param) {
    return request("/app/abroad-blno-subscribe/delete", "post", param, {
        baseURL,
    });
}

/**
 * @description 置顶
 * @param {Number} id
 */
export function abroadSinglePageSubsSetTopOrNot(param) {
    return request(`/app/abroad-blno-subscribe/setTop/${param.id}`, "get", "", {
        baseURL,
    });
}

/**
 * @description 获取节点经纬度
 * @param {String[]} ports 节点
 */
export function getLatLongByQuestion(param) {
    const { data, token } = param;
    return request(
        "/app/abroad-blno-subscribe/getAIS",
        "post",
        data,
        {
            headers: {
                Authorization: token,
            },
            // baseURL: "http://54.179.123.149:10888",
            // headers: {
            //     "Content-Type": "application/x-www-form-urlencoded",
            // },
        },
        // true,
    );
}
